var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanelInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6129 7.01318C11.5265 7.01318 11.9834 7.60539 11.9834 8.28395C11.9834 9.13135 11.1897 9.91511 10.1568 9.91511C9.29154 9.91511 8.787 9.4281 8.81086 8.62291C8.81086 7.94565 9.41154 7.01318 10.6129 7.01318ZM7.80177 20.0001C7.0804 20.0001 6.552 19.5767 7.05654 17.7118L7.88427 14.4053C8.02813 13.8768 8.052 13.6644 7.88427 13.6644C7.66813 13.6644 6.73268 14.0294 6.17836 14.3898L5.81836 13.8183C7.572 12.3989 9.5895 11.5671 10.4554 11.5671C11.1761 11.5671 11.2961 12.3937 10.9361 13.6644L9.98768 17.1397C9.81995 17.7534 9.89154 17.9651 10.06 17.9651C10.2761 17.9651 10.9852 17.7105 11.682 17.1813L12.0911 17.7099C10.3852 19.3638 8.52177 20.0001 7.80177 20.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 10.8224L0 9.09085L10 0L13.6364 3.30084V1.08224H16.3636V5.79001L20 9.09085L18.9091 10.8224L10 2.73267L1.09091 10.8224Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelInfo);
export default __webpack_public_path__ + "static/media/PanelInfo.f4cd63fd9dd4c222880ef04f063532eb.svg";
export { ForwardRef as ReactComponent };